import { apiClient, API_CONFIG } from '@/api/core';
import { buildQueryString } from '@/api/shared';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetRoleMembersOut, LC_GetRoleMembersParams, LC_SaveRoleMembersIn } from './roleMembers.types';


export class RoleMembersService {
  async getMembers(
    roleId: number,
    params?: LC_GetRoleMembersParams,
  ): Promise<ApiResponse<LC_GetRoleMembersOut>> {
    const query = buildQueryString(params ?? {});
    return apiClient.get<LC_GetRoleMembersOut>(
      `${API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLE_MEMBERS(roleId)}${query}`,
    );
  }

  async getNonMembers(
    roleId: number,
    params?: LC_GetRoleMembersParams,
  ): Promise<ApiResponse<LC_GetRoleMembersOut>> {
    const query = buildQueryString(params ?? {});
    return apiClient.get<LC_GetRoleMembersOut>(
      `${API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLE_NON_MEMBERS(roleId)}${query}`,
    );
  }

  async patchMembers(
    roleId: number,
    body: LC_SaveRoleMembersIn,
  ): Promise<ApiResponse<void>> {
    return apiClient.patch<void>(
      API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLE_MEMBERS(roleId),
      body,
    );
  }
}

export const roleMembersService = new RoleMembersService();
